<!-- 
<section class="container-fluid">
<div class="about-container"> -->

    <div class="login-container mx-auto">
        <h2>LOGIN</h2>
        <!-- <button type="button" class="close" (click)="closeModel()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button> -->
        <div class="card-body">
            <form [formGroup]="loginForm" class="px-4" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label for="username">Username</label>
                    <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                    <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                        <div *ngIf="f.username.errors.required">Username is required</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                    </div>
                </div>
                <div class="form-group text-center">
                    <button [disabled]="loading" class="btn btn-secondary btn-login">
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        Login
                    </button>
                </div>
                <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                <div>
                  <a style="font-size: xx-small;" [routerLink]="['/forgotpassword']"> Forgot Password </a>
                </div>
                
            </form>
        </div>
      </div>
  <!-- 
  </div>
  </section> -->